import { gql } from "@apollo/client";

export const GET_ALL_SMTP_AND_IMAP_DATA = gql`
query GetSmtp {
  getSmtp {
  smtp {
    _id
    host
    password
    port
    protocol
    senderEmail
    senderName
    ssl
    userName
  }  
  imap {
    _id
    host
    password
    port
    protocol
    ssl
    userName
  }
  }
}
`